import { Component, OnInit } from '@angular/core';
import { ObservacoesLaudosService } from "./observacoes-laudos.service";
import { ObservacoesLaudosModel } from "./observacoes-laudos.model";
import { Global } from "../global";
import { Components } from "../shared/components/components";
import { TranslateService } from '@ngx-translate/core';
import { Router } from "@angular/router";
import { Funcoes } from "../funcoes";
import { LoginService } from "../login/login.service";

declare var swal: any;

@Component({
  selector: 'app-observacoes-laudos',
  templateUrl: './observacoes-laudos.component.html'
})
export class ObservacoesLaudosComponent extends Components implements OnInit {

  observacoes: ObservacoesLaudosModel[] = [];
  privilegioUsuario = { "editar": false, "consultar": false };

  constructor(
    private observacoesLaudosService: ObservacoesLaudosService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for (let i in data.privilegios) {
        if (data.privilegios[i].id_acao == '24') {
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });
  }

  ngOnInit() {
    this.carregandoTabela = true;
    this.observacoesLaudosService.getPaginacao(1, this.itensPorPagina)
      .subscribe(data => {
        this.observacoes = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;

        if (this.global.debug) {
          console.log(this.observacoes);
        }
      },
        error => {
          this.func.showErro(error.json());
          this.carregandoTabela = false;
        });
  }

  delete(observacao) {
    let observacoes = this.observacoes;
    let observacoesService = this.observacoesLaudosService;
    let self = this;
    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaDeletarObservacao') + (observacao.observacao_pt || ''),
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    },
      function () {
        if (self.global.debug == true) {
          console.log(observacoes);
        }

        let index = observacoes.indexOf(observacao);
        observacoes.splice(index, 1);

        observacoesService.apagar(observacao.id)
          .subscribe(res => {
            self.observacoes = observacoes;
          },
            err => {
              observacoes.splice(index, 0, observacao);
              self.observacoes = observacoes;
              self.func.showErro(err.json());
            });

      });
  }

  getPage(pagina) {
    this.paginaAtual = pagina;
    this.carregandoTabela = true;
    this.observacoesLaudosService.getPaginacao(pagina, this.itensPorPagina)
      .subscribe(data => {
        this.observacoes = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },
        error => {
          this.func.showErro(error.json());
          this.carregandoTabela = false;
        });
  }

}



// WEBPACK FOOTER //
// ./src/app/laudos-cd-observacoes/observacoes-laudos.component.ts